import { render, staticRenderFns } from "./ItineraryFlight.vue?vue&type=template&id=2d859714&scoped=true&"
import script from "./ItineraryFlight.vue?vue&type=script&lang=js&"
export * from "./ItineraryFlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d859714",
  null
  
)

export default component.exports